module.exports = __webpack_public_path__ + "img/Flag_of_Nigeria.6fea46be.svg";